import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert, Button, Container, Form, Spinner } from "react-bootstrap";

import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { register } from "../../actions/authActions";

const SignupAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    address: "",
    password: "",
    confirm_password: "",
    role_id: "admin",
  });

  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");

  const { username, email, phone, address, password, confirm_password, role_id } = formData;

  const onChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setApiError("");
    setApiSuccess("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm_password) {
      setApiError("Passwords do not match.");
      return;
    }

    setSubmitting(true);
    setApiError("");
    setApiSuccess("");
    try {
      const result = await dispatch(
        register({
          username: username.trim(),
          email: email.trim(),
          phone,
          address: address.trim(),
          password,
          role_name: role_id,
        })
      );

      if (result?.ok) {
        setApiSuccess("Account created successfully. Redirecting to login…");
        navigate("/login", { replace: true, state: { signupSuccess: true } });
      } else {
        setApiError(result?.error || "Unable to sign up. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Navbar />
      <Container fluid className="d-flex justify-content-center">
        <Form className="form-container p-4" onSubmit={onSubmit}>
          <h3>Signup</h3>

          {apiError && <Alert variant="danger">{apiError}</Alert>}
          {apiSuccess && <Alert variant="success">{apiSuccess}</Alert>}

          <Form.Group className="form-column">
            <Form.Label>Username</Form.Label>
            <Form.Control type="text" name="username" value={username} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" name="email" value={email} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Address</Form.Label>
            <Form.Control type="text" name="address" value={address} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Phone</Form.Label>
            <Form.Control type="number" name="phone" value={phone} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" name="password" value={password} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control type="password" name="confirm_password" value={confirm_password} onChange={onChange} required disabled={submitting} />
          </Form.Group>
          <Form.Group className="form-column">
            <Form.Label>Role</Form.Label>
            <Form.Control as="select" name="role_id" value={role_id} onChange={onChange} required disabled={submitting}>
              <option value="admin">Admin</option>
              <option value="fleetrole">Distributors/Retailers</option>
              <option value="companyrole">Fleets/Corporate Clients</option>
              <option value="thirdprole">3rd Party Suppliers</option>
              <option value="workshoprole">Workshops/Garages</option>
              <option value="b2crole">B2C Customers</option>
            </Form.Control>
          </Form.Group>
          <Button variant="primary" type="submit" className="login-button d-inline-flex align-items-center gap-2" disabled={submitting}>
            {submitting && <Spinner animation="border" size="sm" />}
            {submitting ? "Submitting…" : "Signup"}
          </Button>
          <div className="mt-3">
            Do you have an account?
            <Link to={"/login"}>
              <span> Login here</span>
            </Link>
          </div>
        </Form>
      </Container>
      <Footer />
    </div>
  );
};

export default SignupAdmin;
